import { Container, Link as MuiLink, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SearchEnvCard } from "../components/searchEnv/SearchEnvCard";

// Standalone search-env detail page — direct linkable, shareable URL
// for one specific env. The actual lifecycle UI is delegated to
// SearchEnvCard, which is the same component used inside the
// workflow-detail SearchEnvPanel. This page is just the chrome
// around it.
//
// Linked to from SearchEnvsList rows and from the back-link inside
// SearchEnvPanel ("open detail page →").

export function SearchEnvDetail() {
  const { envId } = useParams<{ envId: string }>();
  if (!envId) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography>Missing env id.</Typography>
      </Container>
    );
  }
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Stack spacing={2}>
        <MuiLink
          component={RouterLink}
          to="/search-envs"
          variant="caption"
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
        >
          <ArrowBackIcon fontSize="inherit" />
          All search envs
        </MuiLink>
        <Typography variant="h4" sx={{ fontFamily: "monospace" }}>
          {envId}
        </Typography>
        <SearchEnvCard envId={envId} sectioned />
      </Stack>
    </Container>
  );
}
